jQuery(document).ready(function ($) {
    var $show_button = $('#disqus-comments>[overflow]').children('i');

    var $comments_section = $('#disqus-comments');

    $show_button.on('click', function (e) {
        e.preventDefault();

        $comments_section.css(
            'height',
            $('#disqus-comments iframe')
                .contents()
                .find('#disqus_thread')
                .outerHeight() + 30
        );
        $show_button.parent().css('display', 'none');

        return false;
    });
});
